import { Component, NgZone, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
declare let $: any;

@Component({
  selector: 'jhi-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: []
})
export class ConfirmationModalComponent implements OnInit {

  public myContent;
  public id;

  title: string;
  message: string;
  list: any[] = [];

  public onClose: Subject<boolean>;

  constructor(
    public _bsModalRef: BsModalRef,
    private modalService: BsModalService
  ) { }

  public ngOnInit(): void {
    this.onClose = new Subject();

  }

  ngAfterViewInit() {
    // console.log(this.myContent,"this.myContent");
  }
  public onConfirm(): void {
    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
    setTimeout(() => {
      $(document.body).addClass("modal-open");
    }, 1000);
  }
}
